export interface IBlogListingConfig {
    header: string;
    categoryFilterText: string;
    categoryFilterDefaultChoice: string;
    dateFilterText: string;
    dateFilterDefaultChoice: string;
    searchLabelText: string;
    searchPlaceholderText: string;
    searchButtonLabel: string;
    resetFiltersText: string;
    noResultMessage: string;
    pageSize: number;
}

const model = (window as any).filterSectionModel ?? {};

// header/category/reset/noResult/pageSize come from the CMS (BlogFilterPageConfig);
// the date heading and search strings are deliberately hardcoded — not CMS fields.
export const blogListingConfig: IBlogListingConfig = {
    header: model.header || 'Filters',
    categoryFilterText: model.categoryFilterText || 'Filter By Category',
    categoryFilterDefaultChoice: 'All Categories',
    dateFilterText: 'Date',
    dateFilterDefaultChoice: 'All Dates',
    searchLabelText: 'Search articles',
    searchPlaceholderText: 'Search',
    searchButtonLabel: 'Search',
    resetFiltersText: model.resetFiltersText || 'Reset',
    noResultMessage: model.noResultMessage || '<p>No results found.</p>',
    pageSize: typeof model.pageSize === 'number' && model.pageSize > 0 ? model.pageSize : 10,
};
